import { Localization } from '@mui/material/locale';
import createTheme, { DashboardTheme } from './common';

export const createLightTheme = (localization?: Localization): DashboardTheme =>
  createTheme('light', localization);
